// import loginImageMU from "../assets/background.svg";
import logoImageMU from "../assets/logoMu.png";
import logoImageMGU from "../assets/logo-mgu.png";
import suLogo from "../app/icons/su-logo.png";
import suLogoWhite from "../app/icons/su-logo-white.png";

export const tenants = {
  NONE: "_none_",
  MGU: "mgu",
  MU: "mu",
  SU: "su",
};

export const mguExporter = process.env.REACT_APP_TENANT === tenants.MGU ? false : undefined;

export const universityDisplayName = {
  mgu: "МГУ - София",
  mu: "МУ – София",
  su: "СУ – София",
};

export const getUniName = tenantValue => {
  return universityDisplayName[tenantValue] || "Неизвестен университет";
};

export const getUniversityName = tenantValue => {
  if (tenantValue === tenants.MU) return "МУ София";
  if (tenantValue === tenants.MGU) return "МГУ";
  return null;
};

export const tenantLoginConfig = {
  mu: {
    title: "Медицински университет - София",
    // backgroundImage: loginImageMU,
    background: "linear-gradient(180deg, #4E2683 0%, #9c68e2 100%)",
    logo: logoImageMU,
    logoBackground: "",
    buttonColor: "#9D1B53",
    buttonHoverColor: "#4E2683",
    titleColor: "#361B5C",
    subTitleColor: "#9D1B53",
  },
  mgu: {
    title: "Минно-геоложки университет „Св. Иван Рилски“",
    // backgroundImage: loginImageMU,
    background: "linear-gradient(180deg, #022F8B 0%, #1B61D4 100%)",
    logo: logoImageMGU,
    logoBackground: "#1B61D4",
    buttonColor: "#ff7200",
    buttonHoverColor: "#ff9800",
    titleColor: "#022F8B",
    subTitleColor: "#e31212",
  },
  su: {
    title: "Софийски университет „Св. Климент Охридски“",
    background: "linear-gradient(180deg, #7A005E 0%, #5c0247ff 100%)",
    logo: suLogo,
    subTitleColor: "#5c0247ff",
  },
};
export const getLogo = tenantValue => {
  switch (tenantValue) {
    case "su":
      return suLogoWhite;

    default:
      return "";
  }
};
